import { create } from 'zustand';
import { getGroupDevices } from '../api/api';

export const useDevicesStore = create((set, get) => ({
  devices: [],
  devicesExist: false,
  groupDevices: [],
  loading: true,
  _groupDevicesInFlight: null,

  getGroupDevices: async () => {
    const inFlight = get()._groupDevicesInFlight;
    if (inFlight) return inFlight;

    const promise = (async () => {
      const hasData = get().groupDevices?.length > 0;
      if (!hasData) set({ loading: true });
      try {
        await getGroupDevices(
          (data) => {
            set({
              groupDevices: data?.object_devices,
              devices: data?.object_devices?.flatMap((i) => i.devices) ?? [],
              devicesExist: data?.count > 0,
              loading: false,
            });
          },
          () => set({ loading: false })
        );
      } finally {
        set({ _groupDevicesInFlight: null });
      }
    })();

    set({ _groupDevicesInFlight: promise });
    return promise;
  },
}));
